export interface ClearDischargeFormDto {
  reason: string;
}

export const createClearDischargeFormDto = (): ClearDischargeFormDto => {
  return { reason: "" };
};
